import React from 'react'

import LoadingButton from '../ui/LoadingButton'

const Login = ({authenticate, onChange, loginForm, loginMessage, isLoading}) => {

    const onSubmit = e => {
        e.preventDefault()

        authenticate()
    }

    return (
        <React.Fragment>
            <section className="login login-page__section">
                <h2>Login</h2>

                {loginMessage ? (
                    <div className="alert alert-danger">
                        {loginMessage}
                    </div>
                ) : null}

                <form id="login" onSubmit={onSubmit}>
                    <div className="form-group">
                        <input type="text" className="form-control" name="partnerId" placeholder="Partner-ID"
                               value={loginForm.partnerId} onChange={onChange} autoFocus />
                    </div>

                    <div className="form-group">
                        <input type="password" className="form-control" name="partnerPassword" placeholder="Passwort"
                               value={loginForm.partnerPassword} onChange={onChange} />
                    </div>

                    <LoadingButton isLoading={isLoading} className="login__button"/>
                </form>
            </section>

            <section className="app-information-section login-page__section">
                 Die Campaign Preview ist optimiert für Browser:
                <strong>Chrome, Firefox, Safari</strong> und <strong>Microsoft Edge</strong>.
            </section>
        </React.Fragment>
    )
}

export default Login



// WEBPACK FOOTER //
// ./src/components/pages/Login.js